import React, { useContext, useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Edit.module.css'
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { AppContext } from '../../../../providers/appProvider';
import { selectStyle } from './selectStyle';
import Pen from "../../../../assets/Icon/Pen";
import Form from '../../../../assets/Style/Form.module.css'
import Select from "react-select";
import { formatDate } from '../../../../utils/date';
import DateSelect from '../../../UI/Inputs/DateSelect';
import { Link, Navigate } from 'react-router-dom'; 

const ContainerPriceEditModal = ({ ContainerPriceService, defaultContainerPrice }) => {
    const ContainerPriceResetData = {
        id: 0,
        name: "",
    }

    const initEditPrice = (ContainerPrice) => {
        return {
            id: ContainerPrice.id,
            total_price: ContainerPrice.total_price,
            other_price: ContainerPrice.other_price,
            frast_price: ContainerPrice.frast_price || 0,
            thc_price: ContainerPrice.thc_price || 0,


            client_total_price: ContainerPrice.client_total_price,
            client_other_price: ContainerPrice.client_other_price,
            client_frast_price: ContainerPrice.client_frast_price || 0,
            client_thc_price: ContainerPrice.client_thc_price || 0,

            type_id: ContainerPrice.type_id || 0,
            
            sender_country_id: ContainerPrice.sender_country?.id || 0,
            sender_city_id: ContainerPrice.sender_city?.id || 0,
            reciever_country_id: ContainerPrice.reciever_country?.id || 0,
            reciever_city_id: ContainerPrice.reciever_city?.id || 0,
            marine_line_id: ContainerPrice.marine_line?.id || 0,
            agent_id: ContainerPrice.agent?.id || 0,
            period_start_at: ContainerPrice?.period_start_at || formattedDate,
            period_end_at: ContainerPrice?.period_end_at || formattedDate,
            is_active: ContainerPrice.is_active ?? true,
        }
    }

    let currentDate = new Date();
    let formattedDate = formatDate(currentDate);

    const initialTypeOptions = [
        { value: 0, label: 'საზღვაო' },
        { value: 1, label: 'სახმელეთო' },
        { value: 2, label: 'სარკინიგზო' },
        { value: 3, label: 'საჰაერო' },
    ];

    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);

    const { appState, app } = useContext(AppContext);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

    const [newPrice, setNewPrice] = useState(ContainerPriceResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validatePrice = (ContainerPrice) => {
        const messages = {};

        if (ContainerPrice.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.sender_city_id < 1) {
            messages.sender_city_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }


        if (ContainerPrice.agent_id < 1) {
            messages.agent_id = { message: 'სავალდებულოა', isValid: false };
        }
        
 
        if (ContainerPrice.marine_line_id < 1 && ContainerPrice.type_id === 0 ) {
            messages.marine_line_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (ContainerPrice.period_start_at.length < 1) {
            messages.period_start_at = { message: 'სავალდებულოა', isValid: false };
        } 

        if (ContainerPrice.period_end_at.length < 1) {
            messages.period_end_at = { message: 'სავალდებულოა', isValid: false };
        } 


        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validatePrice(newPrice)
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validatePrice(newPrice)
        }
    }, [newPrice, isFirstValidated]);

    useEffect(() => {
        const editedCar = initEditPrice(defaultContainerPrice)
        setNewPrice(editedCar)
    }, [defaultContainerPrice]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {
        const isValidate = validatePrice(newPrice)

        if (isValidate === true) {
            ContainerPriceService.update(newPrice)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
    };

    const handlePriceChange = async (event) => {
        let val = event.target.value;
        setNewPrice(prevPrice => ({
            ...prevPrice,
            [event.target.name]: val
        }));
    };

    const handlePriceIntChange = async (event) => {
        let val = convertToInt(event.target.value);
        setNewPrice(prevPrice => ({
            ...prevPrice,
            [event.target.name]: val
        }));
    };

    const handleTypeIdChange = (selectedOption) => {
        setNewPrice(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)

        if (newPrice.marine_line_id && newPrice.marine_line_id > 0) {
          //  setTypeOptions([{ value: 0, label: 'საზღვაო' }]);
        }
    }

    const handleSenderDateChange = (date) => {
        setNewPrice(prevState => ({
            ...prevState,
            period_start_at: date ? date : "",
        }));
    };

    const handleRecieverDateChange = (date) => {
        setNewPrice(prevState => ({
            ...prevState,
            period_end_at: date ? date : "",
        }));
    };

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };

    return (
        <div>
            <span className={cl.editBtn} onClick={() => openAdd()} >
                <Pen /> განახლება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Pen /></span> განახლება</h3>
                </div>

                <fieldset className={cl.formField}>
                    <legend>ჩატვირთვის პორტი</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newPrice.sender_country_id}
                        childId={newPrice.sender_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (sender_country_id, sender_city_id) => {
                            setNewPrice(prevState => ({
                                ...prevState,
                                sender_country_id: sender_country_id ? sender_country_id : 0,
                                sender_city_id: sender_city_id ? sender_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub="პორტი"
                        validate={validates && validates.sender_country_id ? true : false}
                        validateSub={validates && validates.sender_city_id ? true : false}
                    />
                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიღების პორტი</legend>

                    <MultiSelect
                        parentOptions={appState.countries}
                        childOptions={appState.cities}
                        parentId={newPrice.reciever_country_id}
                        childId={newPrice.reciever_city_id}
                        isNetwork={true}
                        styles={selectStyle}
                        onChange={async (reciever_country_id, reciever_city_id) => {
                            setNewPrice(prevState => ({
                                ...prevState,
                                reciever_country_id: reciever_country_id ? reciever_country_id : 0,
                                reciever_city_id: reciever_city_id ? reciever_city_id : 0,
                            }))
                        }}
                        join={"country_id"}
                        placeholder="ქვეყანა"
                        placeholderSub="პორტი"
                        validate={validates && validates.reciever_country_id ? true : false}
                        validateSub={validates && validates.reciever_city_id ? true : false}
                    />
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>ტიპი</legend>
                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newPrice.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                        />
                    </div>
                </fieldset>

                {/* 
                    {newPrice.type_id === 0  && 
                        //  ეს ამოვარდე რადგან საჭიროა საზღვაო ხაზის დამატება და ყველა ტიპისთვის
                  }
                */}

 
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <legend>საზღვაო ხაზი</legend>
                        <div style={{ width: "50%" }}>
                            <Select
                                styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                                options={marines}
                                value={marines.find(option => option.value === newPrice.marine_line_id)}
                                onChange={(selectedOption) => {
                                    setNewPrice(prevState => ({
                                        ...prevState,
                                        marine_line_id: selectedOption ? selectedOption.value : 0,
                                    }));

                                    if (selectedOption) {
                                        // setTypeOptions([{ value: 0, label: 'საზღვაო' }]);

                                        setNewPrice(prevState => ({
                                            ...prevState,
                                           // type_id: 0,
                                        }));
                                    } else {
                                        setTypeOptions(initialTypeOptions);
                                    }

                                }}
                                placeholder="საზღვაო ხაზი"
                                isClearable={true}
                            />
                        </div>

                        <div style={{ width: "50%", display: 'flex', alignItems: 'center' }}>
                            <Link className={cl.Btn} to="/databases/marine_lines">
                                საზღვაო ხაზის დამატება
                            </Link> 
                        </div>


                    </fieldset>
                


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>აგენტი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.agent_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={agents}
                            value={agents.find(option => option.value === newPrice.agent_id)}
                            onChange={(selectedOption) => {
                                setNewPrice(prevState => ({
                                    ...prevState,
                                    agent_id: selectedOption ? selectedOption.value : 0,
                                })); 
                            }}
                            placeholder="აგენტი"
                            isClearable={true}
                        />
                    </div>
                    <div style={{ width: "50%", display: 'flex', alignItems: 'center' }}>
                        <Link className={cl.Btn} to="/databases/agents">
                               აგენტის დამატება
                        </Link> 
                    </div>

                </fieldset>



                <div style={{ display: "flex", marginTop: '20px', gap: 10 }}>

                    <div  style={{ width: "50%" }} className={ validates && validates.period_start_at ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                        <label>დაწყების პერიოდი</label> 
                        <DateSelect
                            defDate={newPrice.period_start_at}
                            onChange={handleSenderDateChange}
                            placeholderText=""
                            popperClassName={cl.dataContainer}
                            wrapperClassName={cl.dataContainer}
                            className={cl.input  }
                            isClearable
                        />
                    </div>

                    <div  style={{ width: "50%" }} className={ validates && validates.period_end_at ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}>
                        <label>დამთავრების პერიოდი</label> 

                        <DateSelect
                            defDate={newPrice.period_end_at}
                            onChange={handleRecieverDateChange}
                            placeholderText=""
                            popperClassName={cl.dataContainer}
                            wrapperClassName={cl.dataContainer}
                            className={cl.input  }
                            isClearable
                        />


                    </div>
 
 

                </div>

 

                {newPrice.type_id === 0 ? (
                    <div style={{ display: "flex", marginTop: '20px' }}>
  
                        <div style={{width:'50%'}}> 
                            
                            <div className={cl.groupPrice }>
                                <label className={cl.leftLabel}>კომპანიის ფრასტ ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="frast_price" className={Form.input} value={newPrice.frast_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice }>
                                <label className={cl.leftLabel}>კომპანიის THL ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="thc_price" className={Form.input} value={newPrice.thc_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>


                            <div className={cl.groupPrice }>
                                <label className={cl.leftLabel}>კომპანიის სხვა ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="other_price" className={Form.input} value={newPrice.other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                        </div>



                        <div style={{width:'50%'}}> 
                            
                            <div className={cl.groupPrice + ' '+ cl.groupPriceLeft}>
                                <label className={cl.leftLabel}>კლიენტის ფრასტ ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_frast_price" className={Form.input} value={newPrice.client_frast_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice + ' '+ cl.groupPriceLeft}>
                                <label className={cl.leftLabel}>კლიენტის THL ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_thc_price" className={Form.input} value={newPrice.client_thc_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>


                            <div className={cl.groupPrice + ' '+ cl.groupPriceLeft}>
                                <label className={cl.leftLabel}>კლიენტის სხვა ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_other_price" className={Form.input} value={newPrice.client_other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                        </div>
 
  
                    </div>
                ) : (
                    <div style={{ display: "flex", marginTop: '20px' }}>

                        <div style={{width:'50%'}}> 

                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>კლიენტის ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_total_price" className={Form.input} value={newPrice.client_total_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice}>
                                <label className={cl.leftLabel}>კლიენტის სხვა ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="client_other_price" className={Form.input} value={newPrice.client_other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>  
                        
                        </div>  

     
                        <div style={{width:'50%'}}> 
 
                            <div className={cl.groupPrice + ' '+ cl.groupPriceLeft}>
                                <label className={cl.leftLabel}>კომპანიის ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="total_price" className={Form.input} value={newPrice.total_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>

                            <div className={cl.groupPrice + ' '+ cl.groupPriceLeft}>
                                <label className={cl.leftLabel}>კომპანიის სხვა ფასი</label>
                                <div className={cl.rightInput}>
                                    <div className={Form.priceInput}>
                                        <div className={Form.priceCurrency}>
                                            USD
                                        </div>
                                        <input type="text" onKeyPress={handleKeyPress} name="other_price" className={Form.input} value={newPrice.other_price} onChange={handlePriceIntChange} min="0" />
                                        <div className={Form.hundred} >.00</div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>


                    </div>
                )}

  

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>
            </Modal>
        </div>
    );
};

export default ContainerPriceEditModal;
